import { AppState } from 'common/appState';

export const getProcessingImportStatus = (state: AppState) => state.import.isProcessing;
export const getImportErrors = (state: AppState) => state.import.errors;
